<template>
  <section class="nav-container">
    <div class="wd">
      <Row class="nav-header">
        <i-col span="4" class="logo">
          <a href="/">
            <img src="@/assets/logo.png" />
          </a>
        </i-col>
        <i-col span="15" id="nav-menu">
          <Menu
            class="menu-header"
            mode="horizontal"
            theme="primary"
            active-name="1"
          >
            <Submenu name="1">
              <template slot="title">一起创作</template>
              <MenuItem name="1-0">
                <a
                  href="/static/scratch3/index.html?scene=create"
                  target="_blank"
                  >Scratch创作</a
                >
              </MenuItem>
              <MenuItem name="1-1">
                <a href="/static/scratchjr/home.html" target="_blank">ScratchJr创作</a>
              </MenuItem>
              <MenuItem name="1-1">
                <a href="/static/python/" target="_blank">Python创作</a>
              </MenuItem>
              <!-- <MenuItem name="1-2">
                <router-link to="/gamecourse">编程游戏</router-link>
              </MenuItem>
              <MenuItem name="1-3">
                <router-link to="/onehour">编程一小时</router-link>
              </MenuItem> -->
            </Submenu>
            <MenuItem name="2" class="community">
              <router-link to="/community">社区</router-link>
            </MenuItem>
            <MenuItem name="3" class="community">
              <router-link to="/match">赛事</router-link>
            </MenuItem>
            <MenuItem name="4" class="community">
              <router-link to="/camp">营地</router-link>
            </MenuItem>
            <Submenu name="5">
              <template slot="title">
                <router-link to="parents">家长</router-link>
              </template>
              <MenuItem name="5-0">陪孩子编程</MenuItem>
              <MenuItem name="5-1">孩子的未来</MenuItem>
              <MenuItem name="5-2">适合您孩子的方案</MenuItem>
              <MenuItem name="5-3">移动端</MenuItem>
            </Submenu>
            <Submenu name="6">
              <template slot="title">
                <router-link to="/mymenu">我的课堂</router-link>
              </template>
              <MenuItem name="6-0">
                <router-link to="/mycourse">在线课程</router-link>
              </MenuItem>
              <MenuItem name="6-1">我的学校</MenuItem>
              <MenuItem name="6-2">最新课程</MenuItem>
              <MenuItem name="6-3">我的档案</MenuItem>
            </Submenu>
            <MenuItem name="7" class="community" style="margin-left:50px">
              <router-link to="shopping">
                <svg-icon
                  style="font-size: 24px; margin-right: 10px"
                  icon-class="cart"
                ></svg-icon>
                课程商场
              </router-link>
              <svg-icon
                v-if="false"
                style="font-size: 20px; margin-right: 10px"
                icon-class="wx"
              ></svg-icon>
            </MenuItem>
          </Menu>
        </i-col>
        <!-- <i-col v-if="false" span="3" class="login">
          <router-link to="shopping">
            <svg-icon
              style="font-size: 24px; margin-right: 10px"
              icon-class="cart"
            ></svg-icon>
            课程商场
          </router-link>
          <svg-icon
            v-if="false"
            style="font-size: 20px; margin-right: 10px"
            icon-class="wx"
          ></svg-icon>
        </i-col> -->
        <i-col span="5" class="login">
          <div v-if="userInfo && userInfo.username" style="display: inline">
            <Menu
              class="menu-header"
              mode="horizontal"
              theme="primary"
              active-name="1"
            >
              <Submenu name="1">
                <template slot="title">
                  <div style="height: 30px; display: inline-block">
                    <img
                      style="
                        width: 30px;
                        border-radius: 50px;
                        top: 9px;
                        position: relative;
                      "
                      :src="
                        wechatInfo
                          ? wechatInfo.headimgurl
                          : '/static/img/avatar.jpg'
                      "
                      alt
                    />
                    <span style="color: #fff; font-size: 16px">{{
                      userInfo && userInfo.realname
                    }}</span>
                  </div>
                </template>
                <MenuItem name="1-1">
                  <router-link to="mycenter">个人中心</router-link>
                </MenuItem>
                <MenuItem name="1-2">
                  <a
                    @click="
                      isShowLogin = true;
                      loginModalType = 'register';
                    "
                    to="mycenter"
                    >修改密码</a
                  >
                </MenuItem>
                <MenuItem name="1-3">
                  <a @click="logout">退出登录</a>
                </MenuItem>
              </Submenu>
            </Menu>
          </div>
          <div v-else style="display: inline">
            <a
              href="javascript:void(0)"
              @click="isShowLogin = true"
              v-show="showLoginBtn"
              >登录</a
            >
            <Button shape="circle" class="join">
              <router-link to="register">免费加入</router-link>
            </Button>
          </div>
        </i-col>
      </Row>
    </div>

    <Modal v-model="isShowLogin" :closable="false" footer-hide width="410px">
      <login
        @closemodal="closeModal"
        v-if="isShowLogin"
        :loginModalType="loginModalType"
      ></login>
    </Modal>

    <Modal
      v-model="isShowBindPhone"
      class="mycourse-bind-phone-modal"
      :mask-closable="false"
    >
      <div slot="footer"></div>
      <div class="header">
        <img src="@/assets/mycenter/banner.png" alt />
      </div>
      <Form :model="formCustom2" label-position="left" :label-width="80">
        <FormItem label="手机号：">
          <i-input
            maxlength="11"
            v-model="formCustom2.phone"
            placeholder="请输入手机号"
          ></i-input>
        </FormItem>
        <FormItem label="验证码：">
          <Row type="flex">
            <i-col span="14">
              <j-graphic-code v-if="isShowBindPhone" @success="generateCode" />
            </i-col>
            <i-col span="10">
              <i-input
                maxlength="4"
                v-model="formCustom2.graphicCode"
                placeholder="请输入图形验证码"
              ></i-input>
            </i-col>
          </Row>
        </FormItem>
        <FormItem label="验证码：" prop="code">
          <Row type="flex">
            <i-col span="14">
              <i-input
                maxlength="6"
                v-model="formCustom2.code"
                @on-focus="showTip = 1"
                placeholder="请输入手机验证码"
              ></i-input>
            </i-col>
            <i-col span="10">
              <Button
                @click="getCode"
                class="submit"
                style="margin-left: 20px"
                >{{ codeText }}</Button
              >
            </i-col>
          </Row>
          <p v-show="showTip">
            {{
              showTip == 1
                ? "请输入您的手机收到的验证码"
                : "验证码已发送，请查收"
            }}
          </p>
        </FormItem>
        <Button
          style="width: 70%; margin: 20px 15%"
          class="submit"
          type="primary"
          @click="handleSubmit2('formCustom2')"
          >提交</Button
        >
      </Form>
    </Modal>
  </section>
</template>

<script>
import Login from "./login.vue";
import {
  setToken,
  setUserInfo,
  getUserInfo,
  removeToken,
  removeUserInfo,
} from "@/utils/auth";
import {
  getTokenBySession,
  registerAndBindWechat,
  logout,
  getSmsCode,
  updateUserInfo,
} from "@/api/";
import { getUserDetail } from "@/api/user";
import JGraphicCode from "@/components/common/JGraphicCode";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      showLoginBtn: true,
      loginModalType: "",
      isShowLogin: false,
      userInfo: null,
      wechatInfo: null,
      isShowBindPhone: false,
      bindPhoneMode: 1, //1注册 2 绑定
      showTip: "",
      codeText: "获取验证码",
      codeClick: true,
      countDown: 60,
      formCustom2: {
        phone: "",
        code: "",
        graphicCode: "",
        jgraphicCode: "",
      },
      updateUserInfo: {
        id: "",
        phone: "",
      },
    };
  },
  components: {
    Login,
    JGraphicCode,
  },
  created() {
    // let userInfoStr = getUserInfo();
    // console.log(userInfoStr);
    // if (
    //   typeof userInfoStr === undefined ||
    //   userInfoStr === "undefined" ||
    //   userInfoStr === null ||
    //   userInfoStr === ""
    // ) {
    //   this.getTokenBySession();
    // } else {
    //   this.userInfo = JSON.parse(userInfoStr);
    // }
    var that = this;
    this.getUserDetail();
    document.addEventListener("hideLoginBtn", function (e) {
      console.log("hideLoginBtn");
      that.showLoginBtn = false;
    });
    document.addEventListener("showLoginBtn", function (e) {
      that.showLoginBtn = true;
    });
  },
  methods: {
    closeModal() {
      this.isShowLogin = false;
    },
    logout() {
      logout().then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.userInfo = null;
          this.wechatInfo = null;
          removeToken();
          removeUserInfo();
          this.$Message.success(res.message);
          setTimeout(() => {
            this.$router.replace("/home");
          }, 500);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getUserDetail() {
      getUserDetail()
        .then((res) => {
          if (res.success) {
            // this.userDetail = res.result;
            this.userInfo = res.result.userInfo;
            this.wechatInfo = res.result.wechatInfo;
            if (
              (this.userInfo.phone == null || this.userInfo.phone == "") &&
              this.userInfo.loginTimes > 4
            ) {
              this.$Message.error(
                "登录已经超过5次了，需要绑定手机才可以继续使用账户"
              );
              this.bindPhoneMode = 2;
              this.isShowBindPhone = true;
            }
          } else {
            this.getTokenBySession();
          }
        })
        .catch((e) => {
          this.getTokenBySession();
        });
    },
    getTokenBySession() {
      getTokenBySession().then((res) => {
        if (res.success) {
          if (res.result.token != null) {
            setToken(res.result.token, true);
            setUserInfo(res.result.userInfo);
            setTimeout(() => {
              window.location.reload();
            }, 200);
          }
          if (
            res.result.userInfo == null &&
            res.result.wechatUserInfo != null
          ) {
            //判断是否已经弹窗过
            if (window.location.href.includes("#auth-qrcode")) {
              console.log("微信授权成功，需要注册用户");
              this.bindPhoneMode = 1;
              this.isShowBindPhone = true;
            }
          }
          history.replaceState(
            {},
            "",
            window.location.href.replace("#auth-qrcode", "")
          );
          // this.$router.push({ name: 'Course' })
        }
      });
    },
    //提交注册信息
    handleSubmit2(name) {
      this.showTip = "";
      if (!this.formCustom2.phone || !this.formCustom2.code) {
        this.$Message.info("请输入完整");
        return;
      }
      if (this.bindPhoneMode == 1) {
        registerAndBindWechat(
          this.formCustom2.phone,
          this.formCustom2.code
        ).then((res) => {
          if (res.success) {
            this.$Message.success(res.message);
            setTimeout(() => {
              window.location.reload();
            }, 200);
          } else {
            this.$Message.info(res.message);
          }
        });
      } else if (this.bindPhoneMode == 2) {
        this.updateUserInfo = {};
        this.updateUserInfo.id = this.userInfo.id;
        this.updateUserInfo.phone = this.formCustom2.phone;
        updateUserInfo(this.updateUserInfo).then((res) => {
          if (res.code === 200) {
            this.$Message.success(res.message);
            this.isShowBindPhone = false;
          } else {
            this.$Message.info(res.message);
          }
        });
      }
    },
    //获取到图形验证码
    generateCode(value) {
      this.formCustom2.jgraphicCode = value.toLowerCase();
    },
    //获取短信验证码
    getCode() {
      // 获取验证码接口
      // 验证码发送成功时执行
      var that = this;
      if (this.formCustom2.jgraphicCode !== this.formCustom2.graphicCode) {
        this.$Message.info("图形验证码错误");
        return;
      }
      if (!this.codeClick) return;
      this.codeClick = false;
      this.countDown = 60;
      getSmsCode(this.formCustom2.phone).then((res) => {
        if (res.success) {
          that.showTip = 2;
          that.codeText = "60秒后重新获取";
          that.intal = setInterval(() => {
            if (that.countDown > 0) {
              that.countDown--;
              that.codeText = that.countDown + "秒后重新获取";
            } else {
              that.codeText = "重新获取验证码";
              that.codeClick = true;
            }
          }, 1000);
        } else {
          that.codeClick = true;
          that.$Message.info(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.nav-container {
  z-index: 999;
  .ivu-menu-submenu-title,
  .ivu-menu-item {
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
    font-weight: 700;
    font-size: 16px;
    transition: unset;
  }
  .ivu-menu-opened {
    background: rgba(0, 0, 0, 0.2);
  }
  .ivu-menu-submenu {
    border-radius: 60px;
    line-height: 42px;
    margin-top: 16px;
  }
  .ivu-menu-drop-list {
    a {
      color: #515a6e !important;
    }
  }
  #nav-menu .ivu-menu-item {
    white-space: nowrap;
  }
}
</style>
<style lang="scss" scoped>
.mycourse-bind-phone-modal {
  .header {
    margin-bottom: 20px;
    max-height: 500px;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .ivu-form {
    padding: 0 10%;
  }
  .ivu-modal-footer {
    display: none;
  }
  .ivu-input {
    height: 40px;
  }
  .submit {
    background: rgba(0, 193, 222, 1);
    border-radius: 0;
    border: none;
    height: 40px;
    line-height: 40px;
    color: #fff;
  }
  p {
    position: absolute;
    font-size: 12px;
    color: #36b24a;
    line-height: 26px;
    background: #fff;
    z-index: 999;
  }
  .ivu-form-item-error-tip {
    line-height: 14px;
    font-size: 12px;
    color: #ff6a00;
  }
}

.nav-container {
  height: 100%;
  .nav-header {
    height: 70px;
    z-index: 999;
    // background: #6f86d6;
    .community {
      margin-top: 6px;
      a {
        transition: unset;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 30px;
        height: 42px;
        line-height: 42px;
        margin-top: 15px;
      }
    }
    .logo {
      margin-top: 7px;
      position: relative;
      a {
        display: block;
        width: 82%;
        img {
          height: 54px;
        }
      }
    }

    .menu-header {
      background: transparent;
    }
    .login {
      line-height: 70px;
      a {
        color: #fff;
        font-weight: bold;
        margin: 0 16px;
        font-size: 16px;
        &:hover {
          color: rgb(130, 202, 109);
        }
      }
      .join {
        color: #fff;
        background: transparent;
        border-width: 1px;
        font-weight: bold;
      }
    }
  }
  a {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/navigation.vue